var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.14516 9.49987C-5.14516 9.16835 -5.01063 8.85041 -4.77117 8.61599C-4.5317 8.38157 -4.20693 8.24987 -3.86828 8.24987H10.9257L5.44275 2.88487C5.20298 2.65015 5.06828 2.33181 5.06828 1.99987C5.06828 1.66793 5.20298 1.34959 5.44275 1.11487C5.68251 0.880154 6.0077 0.748291 6.34678 0.748291C6.68586 0.748291 7.01105 0.880154 7.25081 1.11487L14.9121 8.61487C15.031 8.73098 15.1254 8.86892 15.1897 9.02079C15.2541 9.17265 15.2872 9.33545 15.2872 9.49987C15.2872 9.66429 15.2541 9.82709 15.1897 9.97895C15.1254 10.1308 15.031 10.2688 14.9121 10.3849L7.25081 17.8849C7.01105 18.1196 6.68586 18.2514 6.34678 18.2514C6.0077 18.2514 5.68251 18.1196 5.44275 17.8849C5.20298 17.6502 5.06828 17.3318 5.06828 16.9999C5.06828 16.6679 5.20298 16.3496 5.44275 16.1149L10.9257 10.7499H-3.86828C-4.20693 10.7499 -4.5317 10.6182 -4.77117 10.3838C-5.01063 10.1493 -5.14516 9.83139 -5.14516 9.49987Z",
    fill: "#FF7700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.f4a4d2211498894fa5abbdcb614a0001.svg";
export { ForwardRef as ReactComponent };